import { render, staticRenderFns } from "./LoginTemplateComponent.vue?vue&type=template&id=4bbcd3ae&scoped=true&"
import script from "./LoginTemplateComponent.vue?vue&type=script&lang=js&"
export * from "./LoginTemplateComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoginTemplateComponent.vue?vue&type=style&index=0&id=4bbcd3ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbcd3ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VContainer,VLayout})
